export default {
  /**
   * The entityMapping defines a mapping from the resource name to the vuex store in which it should be stored.
   * There is one required key:
   *  - storage   which should be a function which gets the vuex state as parameter and returns the specific object
   *              where it should be stored.
   *              This function gets the _state_ as parameter, so we don't need to have the store as dependency
   * There are also a few optional parameter:
   *  - defaults  an array of potential relations belonging to the object
   *  - idKey  in case a key other than 'id' is used.
   *  for example:
   *  schedules: {
   *    storage: state => state.schedules,
   *    defaults: {
   *      // initialize a few relations so they will be properly reactive later
   *      groups: [],
   *      lecturers: [],
   *      // ...
   *    }
   *  }
   **/

  classrooms: {
    storage: state => state.classrooms.classrooms,
    defaults: {},
  },
  courses: {
    storage: state => state.courses.courses,
    defaults: {
      myContexts: [],
    },
  },
  events: {
    storage: state => state.events.events,
    defaults: {
      classrooms: [],
      contexts: [],
      eventStudents: [],
      relatedStudents: [],
      groups: [],
      lecturers: [],
      course: null,
    },
  },
  event_students: {
    storage: state => state.events.event_students,
    defaults: {},
  },
  student_event_contexts: {
    storage: state => state.events.student_event_contexts,
    defaults: {},
  },
  groups: {
    storage: state => state.groups.groups,
    defaults: {
      students: [],
      term: null,
    },
  },
  lecturers: {
    storage: state => state.lecturers.lecturers,
    defaults: {},
  },

  event_clusters: {
    storage: state => state.eventSeries.eventClusters,
    defaults: {
      label: null,
      cluster_parameter: '',
      allow_shopping: null,
      last_event: null,
    },
  },
  student_clusters: {
    storage: state => state.eventSeries.studentClusters,
    defaults: {
      finished_at: null,
      events_finished: null,
      student_id: null,
      event_cluster_id: null,
    },
  },
  student_series: {
    storage: state => state.eventSeries.studentSeries,
    defaults: {
      finished_at: null,
      clusters_finished: null,
      status: null,
    },
  },

  my_subscriptions: {
    storage: state => state.studyplan.mySubscriptions,
  },
  student_course_contexts: {
    storage: state => state.subscribables.studentCourseContexts,
    defaults: {
      type: null,
    },
  },
  students: {
    storage: state => state.students.students,
    defaults: {
      groups: [],
      stopDate: null,
    },
  },
  student_subscribables: {
    storage: state => state.studentSubscribables.studentSubscribables,
    defaults: {
      examClassrooms: null,
      student: null,
    },
  },
  subscribable_students: {
    storage: state => state.subscribables.students,
  },
  student_subscribable_groupings: {
    storage: state => state.studentSubscribableGroupings.studentSubscribableGroupings,
    defaults: {
      subscribable: null,
      student: null,
    },
  },
  student_subscribable_answers: {
    storage: state => state.studentSubscribables.studentSubscribableAnswers,
  },
  subscribables: {
    storage: state => state.subscribables.subscribables,
    defaults: {
      course: null,
      event: null,
      eventCluster: null,
      examEvents: null,
      groups: null,
      mySubscription: null,
      studentSubscribables: [],
      subscriptions: [],
      targetGroup: null,
    },
  },
  subscribable_groupings: {
    storage: state => state.subscribableGroupings.subscribableGroupings,
    defaults: {
      subscribables: [],
      studentSubscribableGroupings: [],
    },
  },
  student_characteristic_values: {
    storage: state => state.studyplan.studentCharacteristics,
    defaults: {
      user: null,
    },
  },
  employee_student_characteristics: {
    storage: state => state.studentCharacteristics.studentCharacteristics,
    defaults: {
      studentCharacteristics: null,
    },
  },
  terms: {
    storage: state => state.terms.terms,
  },
  users: {
    storage: state => state.users.users,
  },
  advises: {
    storage: state => state.advises.advises,
    defaults: {
      messages: [],
    },
  },
  advise_messages: {
    storage: state => state.advises.messages,
  },
  student_answers: {
    storage: state => state.subscribables.studentSubscribableAnswers,
  },
  subscriptions: {
    storage: state => state.subscribables.subscriptions,
    defaults: {
      student: null,
    },
  },
  question_templates: {
    storage: state => state.questionTemplates.questionTemplates,
    defaults: {
      questionTemplateAnswers: [],
    },
  },
  question_template_answers: {
    storage: state => state.questionTemplates.questionTemplateAnswers,
    defaults: {
      questionTemplate: null,
    },
  },
  label_groups: {
    storage: state => state.labelGroups.labelGroups,
    defaults: {
      labels: [],
    },
  },
  labels: {
    storage: state => state.labelGroups.labels,
    defaults: {
      labelGroup: null,
    },
  },
  employees: {
    storage: state => state.employees.employees,
    defaults: {},
  },
  assessment_configs: {
    storage: state => state.events.assessment_configs,
    defaults: {},
  },
}
